<template>
  <div id="recruitConsultingModal">
    <div class="consulting__bg" @click="closeConsiltingModal"></div>
    <div class="consulting__container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <p class="consulting__emoji">👩‍💻</p>
          <p class="consulting__title">개인 브랜딩 지원</p>
          <p class="consulting__content">
            코치님이 곧 브랜드입니다.<br>
            카피라이팅 작업을 통해<br>
            코치님만의 페이지를 만들어드려요.
          </p>
        </div>
        <div class="swiper-slide">
          <p class="consulting__emoji">👨‍🏫</p>
          <p class="consulting__title">수업 매너 교육</p>
          <p class="consulting__content">
            처음 하시는 방문 수업이 당황스럽지 않게<br>
            홈핏만의 수업 매너와 가이드를<br>
            미팅 단계에서 교육해 드려요.
          </p>
        </div>
        <div class="swiper-slide">
          <p class="consulting__emoji">🦸‍♀️</p>
          <p class="consulting__title">역량 강화 교육</p>
          <p class="consulting__content">
            온·오프라인 교육 기회 제공과<br>
            최우수/우수 코치들의 노하우를<br>
            공유해 드립니다.
          </p>
        </div>
        <div class="swiper-slide">
          <p class="consulting__emoji">💁‍♀️</p>
          <p class="consulting__title">각종 지원 업무 전담</p>
          <p class="consulting__content">
            원천징수 영수증, 재직증명을 위한 서류 발급 등<br>
            홈핏 활동과 관련된<br>
            제반업무를 처리해 드립니다.
          </p>
        </div>
      </div>
      <div class="consulting__pagenation"></div>
      <i class="consulting__left" />
      <i class="consulting__right" />
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.min.css';
export default {
  name: 'RecruitConsultingModal',
  mounted(){
    this.initializeSwiper()
  },
  methods: {
    initializeSwiper: function(){
      this.swiper = new Swiper('.consulting__container', {
        centeredSlides: true,
        slidersPerView: '1',
        autoHeight: true,
        navigation: {
          nextEl: '.consulting__right',
          prevEl: '.consulting__left'
        },
        pagination: {
          el: ".consulting__pagenation",
          clickable: true,
        },
      });
    },
    closeConsiltingModal(){
      this.$emit('close-consulting-modal')
    }
  }
}
</script>